/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-icon-aligned[_ngcontent-%COMP%]{width:24px!important;height:24px!important;margin-right:8px!important;vertical-align:middle!important}  mat-form-field .mat-form-field-prefix{display:flex!important;align-items:center!important}"];
export { styles as styles };
